<template>
  <v-list v-if="toggle" class="animate__animated animate__slideInUp" v-click-outside="closeToggle">
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title @click="closeToggle">
          <router-link :to="{ name: 'Company.Profile' }" class="item hover:tw-opacity-70  tw-flex tw-items-center menu-link">
            <v-icon left>mdi-account</v-icon> ข้อมูลส่วนตัว
          </router-link>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <!-- <v-list-item>
      <v-list-item-content>
        <v-list-item-title>การชำระเงิน</v-list-item-title>
      </v-list-item-content>
    </v-list-item> -->
    <v-list-item>
      <v-list-item-content>
        <v-list-item-title @click="logout" class="item hover:tw-opacity-70  tw-flex tw-items-center menu-link">
          <v-icon left>mdi-logout</v-icon> <u>ออกจากระบบ</u>
        </v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>

</template>

<script>
import {mapState} from "vuex";

export default {
  name: "ProfileMenu",
  computed: mapState({
    toggle: state => state.drawer.profileMenuToggle,
  }),
  methods:{
    logout: function (){
      this.closeToggle();
      this.$store.dispatch('auth/logout')
    },
    closeToggle: function (){
      this.$store.dispatch('drawer/toggleProfileMenu')
    }
  }
}
</script>

<style scoped lang="scss">
.v-list {
  width: 300px;
  position: fixed;
  z-index: 10;
  bottom: 0;
  left: 0;
  padding-bottom: 150px;
  border-top-right-radius: 20px;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, 0.16) !important;
}
.item{
  cursor: pointer;
}



.item-link{
  color: rgba(0, 0, 0, 0.87) !important;
}
.v-application a{
  color: rgba(0, 0, 0, 0.87) !important;
}

.menu-link:active {
  opacity: 0.3 !important;
  transition: all 0.2s ease-in-out;
}

</style>
